import { animate, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { BroadcastService } from '../../services/broadcast/broadcast.service';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate('0.2s', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        // :leave is alias to '* => void'
        animate('0.2s', style({ opacity: 0 })),
      ]),
    ]),
  ],
  standalone: false,
})
export class LoadingOverlayComponent {
  isLoading: boolean = false;
  isVisible: boolean = false;
  message: string;
  spinner: string;

  constructor(private broadcastService: BroadcastService) {
    this.broadcastService.on('loadingOverlay').subscribe((event: any) => {
      this.setLoadingVisibility(event.data.show);

      this.spinner = event.data.options?.spinner;
      this.message = event.data.options?.message;
    });
  }

  private setLoadingVisibility(show: boolean) {
    this.isLoading = show;

    if (this.isLoading) {
      setTimeout(() => (this.isVisible = true), 1);
    }
  }
}
